<template>
  <div v-if="currentLocale !== 'en' && currentLocale !== 'cn'" class="slogan-ctn">
    <span>
      {{ $t('footer.slogan.we') }}
    </span>
    <div class="heart-icon" />
    <span>
      {{ $t('footer.slogan.weDo') }}
    </span>
  </div>
  <div v-else class="slogan-ctn">
    <span>
      {{ $t('footer.slogan') }}
    </span>
  </div>
</template>
<script>
export default {
  name: 'OnestiSlogan',
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  }
}
</script>
<style scoped lang="sass">
@tailwind utilities

.slogan-ctn
  @apply uppercase flex justify-center items-center

.heart-icon
  @apply w-6 h-6
  margin: 0 .3rem
  background: url('~@/assets/images/icone-coracao.svg') no-repeat
  background-size: contain
</style>
